<template>
  <div class="contentTeam">
    <div class="content_banner">
      <img src="../assets/img/banner/banner_server.jpg" alt="">
    </div>

    <div class="container_wrap contentTeamWrap">
      <el-row :gutter="40">
        <el-col :span="7">
          <div class="contentTeamLeft">
            <img :src="list.img" alt="">
          </div>
        </el-col>
        <el-col :span="17">
          <div class="contentTeamRight">
            <div class="contentTeamTitle">{{ list.name }}</div>
            <div class="contentTeamPosition">{{ list.position }}</div>
            <div class="contentTeamInfo" v-html="list.info"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: {
        id: "",
        name: "",
        img: "",
        position: "",
        info: "",
      }
    }
  },
  mounted() {
    var _this = this
    var urlId = _this.$router.history.current.query.id
    urlId && _this.getListInfo(urlId)
  },
  methods: {
    async getListInfo(id){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamInfoDetail',{id: id});
      if(data.code == 200){
        _this.list = data.data[0]
      }
    },
  }
}
</script>

<style>
.contentTeamWrap {
  padding-top: 50px;
}
.contentTeamLeft {}
.contentTeamLeft img {
  width: 100%;
  height: auto;
}
.contentTeamTitle {
  font-size: 26px;
  line-height: 40px;
  font-weight: bold;
  margin-bottom: 15px;
}
.contentTeamPosition {
  font-size: 18px;
  font-weight: bold;
  line-height: 30px;
  color: #333;
  line-height: 1.5em;
  margin-bottom: 15px;
}
.contentTeamInfo {
  color: #666;
  line-height: 28px;
  font-size: 16px;
}
</style>